import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { moduleService } from "@/services/module.service";
import toast from "react-hot-toast";

export function useModuleEditor() {
  const queryClient = useQueryClient();
  const [editingModule, setEditingModule] = useState<string | null>(null);
  const [editModuleDraft, setEditModuleDraft] = useState({
    name: "",
    description: "",
    icon: "",
    sortOrder: 0,
  });

  const { mutateAsync: updateModule, isPending: isUpdatingModule } =
    useMutation({
      mutationFn: () => {
        if (!editingModule) throw new Error("No module selected for editing");
        return moduleService.updateModule(editingModule, {
          name: editModuleDraft.name,
          description: editModuleDraft.description || undefined,
          icon: editModuleDraft.icon || undefined,
          sortOrder: editModuleDraft.sortOrder,
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["admin-modules"] });
        toast.success("Module updated successfully");
        setEditingModule(null);
      },
      onError: (error: any) =>
        toast.error(error?.message || "Failed to update module"),
    });

  const startEditingModule = (mod: any) => {
    setEditingModule(mod.code);
    setEditModuleDraft({
      name: mod.name,
      description: mod.description || "",
      icon: mod.icon || "",
      sortOrder: mod.sortOrder,
    });
  };

  const getModuleIcon = (icon: string | null | undefined): string => {
    if (!icon) return "📦";
    const emojiRegex = /^[\p{Emoji}]/u;
    if (emojiRegex.test(icon)) return icon;
    return "📦";
  };

  return {
    editingModule,
    setEditingModule,
    editModuleDraft,
    setEditModuleDraft,
    isUpdatingModule,
    updateModule,
    startEditingModule,
    getModuleIcon,
  };
}
